import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

import './ExperienceChip.scss';

const ExperienceChip = ({ name, onClick }) => (
  <Button
    className="ExperienceChip"
    onClick={onClick}
    variant="black-small"
    type="button"
  >
    <span className="ExperienceChip__name" title={name}>
      {name}
    </span>
  </Button>
);

ExperienceChip.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

ExperienceChip.displayName = 'ExperienceChip';

export default ExperienceChip;
